<template>
  <div
    v-if="showAdminAssetModal"
    class="modal top-0 bottom-0 w-full h-full fixed flex justify-center items-center"
  >
    <div class="overlay fixed w-full h-full top-0"></div>
    <div class="modal-content w-full relative">
      <!-- close button -->
      <div
        @click="close"
        class="close absolute flex flex-row justify-center items-center text-white cursor-pointer"
      >
        <img :src="require('../../assets/close.png')" alt="" />
      </div>

      <div class="bg-white px-8 py-4 ">
        <div class="modal-title main-tenant-color font-semibold mb-2">
          New Resource
        </div>
        <div class="flex flex-row">
          <div class="flex flex-col flex-grow items-start mr-12">
            <div class="flex flex-row items-center form-row mb-8">
              <div class="modal-field font-semibold">Asset Name:</div>
              <div class="flex-grow ml-auto">
                <linput
                  type="text"
                  name="fname"
                  v-model="form.asset_name"
                  :errorMessage="errors.asset_name"
                  :error="errors.asset_name"
                  placeholder="Name of Resource"
                />
              </div>
            </div>
            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold">Upload Type:</div>
              <div class="flex-grow ml-auto">
                <lselect
                  selected
                  v-model="type"
                  :items="types"
                  placeholder="Select Upload Type"
                />
              </div>
            </div>
            <div
              v-if="type == 'upload'"
              class="flex flex-row items-center form-row mb-8"
            >
              <div class="modal-field font-semibold ">Upload File:</div>
              <div class="flex-grow ml-auto">
                <vue-dropzone
                  ref="myVueDropzone"
                  id="dropzone"
                  :options="dropzoneOptions"
                  @vdropzone-complete="afterComplete"
                  @vdropzone-file-added="afterComplete"
                ></vue-dropzone>
              </div>
            </div>
            <div v-else class="flex flex-row items-center form-row mb-8">
              <div class="modal-field font-semibold">Asset URL:</div>
              <div class="flex-grow ml-auto">
                <linput
                  type="text"
                  name="fname"
                  v-model="form.file"
                  :errorMessage="errors.file"
                  :error="errors.file"
                  placeholder="Asset URL"
                />
              </div>
            </div>
          </div>
          <div
            v-if="type == 'upload'"
            class="flex flex-col justify-center items-center"
          >
            <div class="mb-2">
              <lms-button
                @click="cloudinaryUpload"
                :color="`#0B85E4`"
                textColor="#fff"
                >Add Resource</lms-button
              >
            </div>
          </div>
          <div v-else class="flex flex-col justify-center items-center">
            <div class="mb-2">
              <lms-button
                @click="handleFormSubmit"
                :color="`#0B85E4`"
                textColor="#fff"
                >Add Resource</lms-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { store } from "@/store/store";
import axios from "axios";
export default {
  data() {
    return {
      errors: [],
      form: {},
      file: "",
      type: "upload",
      types: [
        {
          text: "File Upload",
          value: "upload",
        },
        {
          text: "URL",
          value: "url",
        },
      ],
      dropzoneOptions: {
        url: "http://localhost:8000/api/image",
        maxFilesize: 500, // MB
        maxFiles: 1,
        chunking: true,
        preventDuplicates: true,
        chunkSize: 500, // Bytes
        thumbnailWidth: 150, // px
        thumbnailHeight: 150,
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictDefaultMessage: `<i class='fa fa-file-image-o' style='font-size:100px; text-align: center'></i>
      <br> Upload File`,
      },
    };
  },
  model: {
    prop: "showAdminAssetModal",
    event: "closeAssetModal",
  },
  props: {
    showAdminAssetModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  mounted() {
    this.form = {};
  },
  methods: {
    cloudinaryUpload() {
        const baseUrl = process.env.VUE_APP_API;
        // const endpoint = `https://api.cloudinary.com/v1_1/${this.cloudinary.name}/image/upload`;
        const endpoint = `${baseUrl}/tenant/asset/upload-to-bucket`;
        let LMS_BASE_URL =
            "https://api.cloudinary.com/v1_1/lms-edc/upload/";
        // let UPLOAD_PRESET = "a7xiiluo";
        let config = {
            headers: {
                "content-type": "multipart/form-data",
                Authorization: `Bearer ${store.state.auth.token}`,
            },
        }
      const self = this;

      if (this.file) {
        const formData = new FormData();
        formData.append("asset_file", this.file);
        //Upload Image
        axios
          .post(endpoint, formData,config)
          .then(function(response) {
              self.form.file = response.data.data.file_url;
            self.handleFormSubmit();
          })
          .catch(function(err) {
            //console.log(err);
            self.loading = false;
            self.$swal("Error!", "An error occured, Please try again", "error");
          });
      } else {
        self.loading = false;
        self.$swal("Error!", "You need to select an image", "error");
      }
    },

    createPresignedUrl() {
      return fetch(
        `https://api.edc.hostville.website/v1/tenant/asset/pre-signed?asset_name=${this.form.asset_name}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${store.state.auth.token}`,
          },
        }
      ).then((r) => r.json());
    },
    uploadFile(url, file) {
      return fetch(url, {
        method: "PUT",
        body: file,
      }).then((resp) => {
        return resp.text().then((body) => {
          const result = {
            status: resp.status,
            body,
          };

          if (!resp.ok) {
            return Promise.reject(result);
          }

          return result;
        });
      });
    },
    submitForm(filename) {
      return fetch("/submit", {
        method: "POST",
        body: JSON.stringify({ filename }),
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
    onSubmit() {
      //console.log(this.form);
      // if (this.form.file.files.length < 1) {
      //   alert("select a file please");
      //   return false;
      // }

      var file = this.form.file;

      this.createPresignedUrl()
        .then((res) => {
          //console.log(res);
          return this.uploadFile(res.url, file).then(() => res.filename);
        })
        .then((filename) => {
          return this.submitForm(filename).then(() => {
            //console.log({ filename });
            alert(`Hooray you uploaded ${filename}`);
            form.reset();
          });
        });

      return false;
    },
    ...mapActions(["adminCreateAsset", "fetchAdminAssets"]),
    async afterComplete(upload) {
      this.file = upload;
    },
    async handleFormSubmit() {
      this.errors = [];
      let res = await this.adminCreateAsset({
        asset_name: this.form.asset_name,
        file: this.form.file,
      });

      if (res == true || res.status == 200 || res.status == 201) {
        this.form = {};
        this.fetchAdminAssets();
        this.$emit("notify", {
          type: "success",
          message: "Asset created successfully",
        });

        this.close();
      } else {
        if (res.status == 400) {
          this.$Bus.$emit("notify", {
            type: "error",
            message: res.data.errors
              ? res.data.errors[0].title
              : "An error occured",
          });
        }
      }
    },
    close() {
      this.form = {};
      this.$emit("closeAssetModal", false);
    },
  },
  components: {
    linput: () => import("@/components/general/input"),
    ltextarea: () => import("@/components/general/textarea"),
    LmsButton: () => import("@/components/general/button"),
    lselect: () => import("@/components/forms/select"),
    vueDropzone: vue2Dropzone,
  },
};
</script>
<style lang="scss" scoped>
.form-row {
  width: 100%;
}
.modal {
  z-index: 10;

  .overlay {
    background: #b1b3b9;
    opacity: 0.89;
    z-index: 0;
  }

  .modal-content {
    width: 100%;
    width: 1001px !important;

    .modal-title {
      font-size: 24px;
      color: color(lms-admin);
    }

    .modal-field {
      color: color(lms-admin);
      max-width: calc(135px + 16px);
      width: 100%;
    }

    .close {
      background-color: #c2454b;
      height: 30px;
      width: 30px;
      border-radius: 50%;
      font-size: 12px;
      top: -17px;
      z-index: 2;
      right: -16px;
    }
    z-index: 1;
  }
}
</style>
